import { concatMap } from 'rxjs/operators';
import { getCampaignsPublicMethod } from '../../generated/api/uiApiMethods.js';
import { getCampaignsFailed, getCampaignsFulfilled } from '../actions/campaignsActions.js';
import { TypeKeys } from '../actions/index.js';
import { callUiApi } from '../common/uiApiUtils.js';
import { getMdmIdHeaderFromUrlParams } from './epicUtils.js';
import type { EpicDependencies } from './epicUtils.js';
import type { CampaignsResponse } from '../../generated/api/models.js';
import type { GetCampaignsAction } from '../actions/campaignsActions.js';
import type { ActionTypes } from '../actions/index.js';
import type { State } from '../common/store.js';
import type { Action } from 'redux';
import type { ActionsObservable, Epic, StateObservable } from 'redux-observable';

export const campaignsEpic: Epic<ActionTypes, Action, State, EpicDependencies> = (
  action$: ActionsObservable<ActionTypes>,
  state$: StateObservable<State>,
  epicDependencies: EpicDependencies
) =>
  action$.ofType<GetCampaignsAction>(TypeKeys.GET_CAMPAIGNS).pipe(
    concatMap(({ params }: GetCampaignsAction) => {
      return callUiApi({
        epicDependencies,
        state$,
        method: getCampaignsPublicMethod(params),
        successAction: response => getCampaignsFulfilled(params, response as CampaignsResponse),
        failureAction: getCampaignsFailed,
        headers: getMdmIdHeaderFromUrlParams(),
      });
    })
  );
